export default __webpack_public_path__ + "static/media/banner-1.73dfdbc1.jpg";